export { BottomTabBar } from '@/components/molecules/navigation/BottomTabBar';
export type { BottomTabItem } from '@/components/molecules/navigation/BottomTabBar';
